/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_TitleInputs */

const en_svc_retainer_title = /** @type {(inputs: Svc_Retainer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maintenance and Automation Retainer`)
};

const ar_svc_retainer_title = /** @type {(inputs: Svc_Retainer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عقد صيانة وأتمتة`)
};

const bn_svc_retainer_title = /** @type {(inputs: Svc_Retainer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রক্ষণাবেক্ষণ ও অটোমেশন রিটেইনার`)
};

const de_svc_retainer_title = /** @type {(inputs: Svc_Retainer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wartungs- und Automatisierungs-Retainer`)
};

const es_svc_retainer_title = /** @type {(inputs: Svc_Retainer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retainer de mantenimiento y automatización`)
};

const fr_svc_retainer_title = /** @type {(inputs: Svc_Retainer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forfait de maintenance et d'automatisation`)
};

const pt_svc_retainer_title = /** @type {(inputs: Svc_Retainer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avença de manutenção e automação`)
};

const zh_svc_retainer_title = /** @type {(inputs: Svc_Retainer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`维护与自动化包月`)
};

const tr_svc_retainer_title = /** @type {(inputs: Svc_Retainer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bakım ve Otomasyon Retainerı`)
};

const ru_svc_retainer_title = /** @type {(inputs: Svc_Retainer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ретейнер поддержки и автоматизации`)
};

const pl_svc_retainer_title = /** @type {(inputs: Svc_Retainer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retainer utrzymania i automatyzacji`)
};

/**
* | output |
* | --- |
* | "Maintenance and Automation Retainer" |
*
* @param {Svc_Retainer_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_retainer_title = /** @type {((inputs?: Svc_Retainer_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_title(inputs)
	if (locale === "bn") return bn_svc_retainer_title(inputs)
	if (locale === "de") return de_svc_retainer_title(inputs)
	if (locale === "es") return es_svc_retainer_title(inputs)
	if (locale === "fr") return fr_svc_retainer_title(inputs)
	if (locale === "pt") return pt_svc_retainer_title(inputs)
	if (locale === "zh") return zh_svc_retainer_title(inputs)
	if (locale === "tr") return tr_svc_retainer_title(inputs)
	if (locale === "ru") return ru_svc_retainer_title(inputs)
	if (locale === "pl") return pl_svc_retainer_title(inputs)
	return en_svc_retainer_title(inputs)
});